export const kingAttack = new Image();
kingAttack.src = "./assets/characterSprites/king/kingAttackRev.png";
kingAttack.width = 1280/8
kingAttack.height = 111
kingAttack.yOffset = 38
kingAttack.xOffset = 150
kingAttack.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];